<script>
export default {
    name: 'HerePolyline',
    inject: ['map', 'group'],
    data () {
        return {
            polyline: null
        }
    },
    props: {
        points: {
            type: Array,
            required: true
        },
        color: {
            type: String,
            default: '#AED51B'
        },
        withArrows: {
            type: Boolean,
            default: false
        }
    },
    mounted () {
        this.createLine()
    },
    beforeDestroy () {
        this.removeLine()
    },
    watch: {
        points () {
            if (null == this.polyline) {
                this.createLine()
                return
            }

            this.removeLine()
            this.createLine()
        }
    },
    methods: {
        removeLine () {
            if (null == this.polyline) return

            if (null == this.map()) return

            const target = null != this.group() ? this.group() : this.map()
            target.removeObject(this.polyline)

            this.polyline = null
        },

        createLine () {
            if (null == this.map() || 0 === this.points.length) return

            const lineString = new H.geo.LineString()
            this.points.forEach(p => lineString.pushPoint(p))

            let routeLine = null
            // Initialize a polyline with the linestring:
            if (this.withArrows) {
                let routeArrows = new H.map.Polyline(lineString, {
                    style: {
                        lineWidth: 4,
                        fillColor: 'white',
                        strokeColor: 'rgba(255, 255, 255, 1)',
                        lineDash: [0, 2],
                        lineTailCap: 'arrow-tail',
                        lineHeadCap: 'arrow-head'
                    }
                })

                let polyline = new H.map.Polyline(lineString, {
                    style: {
                        lineWidth: 6,
                        strokeColor: this.color
                    }
                })

                // eslint-disable-next-line no-undef
                routeLine = new H.map.Group()
                routeLine.addObjects([polyline, routeArrows])
            } else {
                routeLine = new H.map.Polyline(
                    lineString,
                    {
                        style: { lineWidth: 6, lineJoin: 'round', lineCap: 'round', strokeColor: this.color, lineTailCap: 'arrow-tail' }
                    }
                )
            }

            const target = null != this.group() ? this.group() : this.map()
            target.addObject(routeLine)

            this.polyline = routeLine
        }
    },
    render () {
        return null
    }
}
</script>
